export default "__VITE_ASSET__BcUYjhYZ__"